import { render, staticRenderFns } from "./allReports.vue?vue&type=template&id=6d021a52&scoped=true"
import script from "./allReports.vue?vue&type=script&lang=js"
export * from "./allReports.vue?vue&type=script&lang=js"
import style0 from "./allReports.vue?vue&type=style&index=0&id=6d021a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d021a52",
  null
  
)

export default component.exports